<template>
	<div>
		<div class="relative z-[15] size-40 overflow-hidden rounded-sm">
			<div class="absolute inset-0 -rotate-1 bg-yellow-300 shadow-2xl"></div>

			<div class="absolute inset-0 px-3 pb-4 pt-8">
				<div
					v-if="spec?.type !== 'entrypoint' && !readonly"
					class="absolute right-1.5 top-0 cursor-pointer p-1"
					title="Delete"
					@click="deleteNode()"
					@touchstart.prevent="deleteNode()"
				>
					<span class="fa-light fa-close text-black"></span>
				</div>
				<img
					src="/img/pin.png"
					height="20"
					alt="Pinboard Pin"
					class="pointer-events-none absolute left-1/2 top-2 h-5 -translate-x-1/2"
				/>
				<textarea
					id="note"
					v-model="noteContent"
					:disabled="readonly"
					name="noteContent"
					class="h-28 resize-none border-0 bg-transparent text-xs text-black outline-none ring-0 placeholder:text-black"
					placeholder="Type your note here..."
				></textarea>
			</div>
		</div>
	</div>
</template>
<script>
import { defineComponent } from 'vue'
import { BaseNodeComponent } from '@jsplumbtoolkit/browser-ui-vue3'

export default defineComponent({
	mixins: [BaseNodeComponent],
	props: ['spec', 'readonly'],
	data() {
		return {
			noteContent: ''
		}
	},
	watch: {
		noteContent: function (value) {
			this.getToolkit().updateNode(this.getNode().id, {
				config: {
					noteContent: this.noteContent
				}
			})
		}
	},
	mounted() {
		this.noteContent = this.getNode().data?.config?.noteContent || ''
	},
	methods: {
		deleteNode: function () {
			this.getToolkit().removeNode(this.getNode())
		}
	}
})
</script>
